export type API_LAYOUTS_FETCH_TYPE = 'API_LAYOUTS_FETCH';
export type API_LAYOUTS_ERROR_TYPE = 'API_LAYOUTS_ERROR';
export type API_LAYOUTS_SUCCESS_TYPE = 'API_LAYOUTS_SUCCESS';

export type API_AUTH_FETCH_TYPE = 'API_AUTH_FETCH';
export type API_AUTH_CERTS_FETCH_TYPE = 'API_AUTH_CERTS_FETCH';
export type API_AUTH_DUO_FETCH_TYPE = 'API_AUTH_DUO_FETCH';
export type API_AUTH_SUCCESS_TYPE = 'API_AUTH_SUCCESS';
export type API_AUTH_ERROR_TYPE = 'API_AUTH_ERROR';
export type API_AUTH_DUO_SUCCESS_TYPE = 'API_AUTH_DUO_SUCCESS';
export type API_AUTH_DUO_ERROR_TYPE = 'API_AUTH_DUO_ERROR';
export type API_AUTH_SET_DUO_TYPE = 'API_AUTH_SET_DUO';
export type API_AUTH_RESET_TYPE = 'API_AUTH_RESET';
export type API_AUTH_CERTS_RESET_TYPE = 'API_AUTH_CERTS_RESET';
export type API_AUTH_CERTS_TYPE = 'API_AUTH_CERTS';
export type API_AUTH_SERVER_TYPE = 'API_AUTH_SERVER';
export type API_SERVICE_TYPE_TYPE = 'API_SERVICE_TYPE';
export type API_DO_AUTH_TYPE = 'API_DO_AUTH';
export type API_CANCEL_AUTH_TYPE = 'API_CANCEL_AUTH';

export type API_START_HEARTBEATEN_TYPE = 'API_START_HEARTBEATEN';
export type API_STOP_HEARTBEATEN_TYPE = 'API_STOP_HEARTBEATEN';

export type API_GET_BOOKMARKS_INFO_TYPE = 'API_GET_BOOKMARKS_INFO';
export type API_SET_BOOKMARKS_INFO_TYPE = 'API_SET_BOOKMARKS_INFO';

export type API_CAMERAS_FETCH_TYPE = 'API_CAMERAS_FETCH';
export type API_CAMERAS_ERROR_TYPE = 'API_CAMERAS_ERROR';
export type API_CAMERAS_SUCCESS_TYPE = 'API_CAMERAS_SUCCESS';

export type API_MAPS_SUCCESS_TYPE = 'API_MAPS_SUCCESS';
export type API_WEBPAGES_SUCCESS_TYPE = 'API_WEBPAGES_SUCCESS';

export type API_GET_DATA_TYPE = 'API_GET_DATA';
export type API_SESSION_TOKEN_IS_OVER_TYPE = 'API_SESSION_TOKEN_IS_OVER';
export type API_GET_EVENTS_INFO_TYPE = 'API_GET_EVENTS_INFO';
export type API_SET_EVENTS_INFO_TYPE = 'API_SET_EVENTS_INFO';
export type API_SET_GLOBAL_TRIGGERS_TYPE = 'API_SET_GLOBAL_TRIGGERS';
export type API_SET_PRIVILLIDGES_TYPE = 'API_SET_PRIVILLIDGES';

////////////////////////////////////////////////////////
export const API_LAYOUTS_ERROR: API_LAYOUTS_ERROR_TYPE = 'API_LAYOUTS_ERROR';
export const API_LAYOUTS_SUCCESS: API_LAYOUTS_SUCCESS_TYPE = 'API_LAYOUTS_SUCCESS';
export const API_LAYOUTS_FETCH: API_LAYOUTS_FETCH_TYPE = 'API_LAYOUTS_FETCH';

export const API_AUTH_FETCH: API_AUTH_FETCH_TYPE = 'API_AUTH_FETCH';
export const API_AUTH_CERTS_FETCH: API_AUTH_CERTS_FETCH_TYPE = 'API_AUTH_CERTS_FETCH';
export const API_AUTH_DUO_FETCH: API_AUTH_DUO_FETCH_TYPE = 'API_AUTH_DUO_FETCH';
export const API_AUTH_SUCCESS: API_AUTH_SUCCESS_TYPE = 'API_AUTH_SUCCESS';
export const API_AUTH_ERROR: API_AUTH_ERROR_TYPE = 'API_AUTH_ERROR';
export const API_AUTH_DUO_SUCCESS: API_AUTH_DUO_SUCCESS_TYPE = 'API_AUTH_DUO_SUCCESS';
export const API_AUTH_DUO_ERROR: API_AUTH_DUO_ERROR_TYPE = 'API_AUTH_DUO_ERROR';
export const API_AUTH_SET_DUO: API_AUTH_SET_DUO_TYPE = 'API_AUTH_SET_DUO';
export const API_AUTH_RESET: API_AUTH_RESET_TYPE = 'API_AUTH_RESET';
export const API_AUTH_CERTS_RESET: API_AUTH_CERTS_RESET_TYPE = 'API_AUTH_CERTS_RESET';
export const API_AUTH_CERTS: API_AUTH_CERTS_TYPE = 'API_AUTH_CERTS';
export const API_AUTH_SERVER: API_AUTH_SERVER_TYPE = 'API_AUTH_SERVER';
export const API_SERVICE_TYPE: API_SERVICE_TYPE_TYPE = 'API_SERVICE_TYPE';
export const API_DO_AUTH: API_DO_AUTH_TYPE = 'API_DO_AUTH';
export const API_CANCEL_AUTH: API_CANCEL_AUTH_TYPE = 'API_CANCEL_AUTH';

export const API_START_HEARTBEATEN: API_START_HEARTBEATEN_TYPE = 'API_START_HEARTBEATEN';
export const API_STOP_HEARTBEATEN: API_STOP_HEARTBEATEN_TYPE = 'API_STOP_HEARTBEATEN';

export const API_GET_BOOKMARKS_INFO: API_GET_BOOKMARKS_INFO_TYPE = 'API_GET_BOOKMARKS_INFO';
export const API_SET_BOOKMARKS_INFO: API_SET_BOOKMARKS_INFO_TYPE = 'API_SET_BOOKMARKS_INFO';

export const API_CAMERAS_FETCH: API_CAMERAS_FETCH_TYPE = 'API_CAMERAS_FETCH';
export const API_CAMERAS_ERROR: API_CAMERAS_ERROR_TYPE = 'API_CAMERAS_ERROR';
export const API_CAMERAS_SUCCESS: API_CAMERAS_SUCCESS_TYPE = 'API_CAMERAS_SUCCESS';

export const API_MAPS_SUCCESS: API_MAPS_SUCCESS_TYPE = 'API_MAPS_SUCCESS';
export const API_WEBPAGES_SUCCESS: API_WEBPAGES_SUCCESS_TYPE = 'API_WEBPAGES_SUCCESS';

export const API_GET_DATA: API_GET_DATA_TYPE = 'API_GET_DATA';
export const API_SESSION_TOKEN_IS_OVER: API_SESSION_TOKEN_IS_OVER_TYPE = 'API_SESSION_TOKEN_IS_OVER';
////////////////////////////////////////////////////////
export const API_GET_EVENTS_INFO = 'API_GET_EVENTS_INFO';
export const API_SET_EVENTS_INFO = 'API_SET_EVENTS_INFO';
export const API_SET_GLOBAL_TRIGGERS = 'API_SET_GLOBAL_TRIGGERS';
export const API_SET_PRIVILLIDGES: API_SET_PRIVILLIDGES_TYPE = 'API_SET_PRIVILLIDGES';